export const isEmpty = entity => !entity || Object.keys(entity).length === 0
export const isEmptyString = string => string.replace(/\s/g, '') === ''